<template>
  <v-container text-xs-center style="max-height: 40vh; max-width: 1054px">
    <v-layout row wrap>
      <v-toolbar
        color="white"
        class="elevation-0"
        height="30"
        style="z-index: 1"
      >
        <v-layout>
          <v-expand-transition class>
            <div xs12 sm3 xl4 style="margin-left: 40px; margin-top: 9px">
              <v-btn
                :disabled="selected.length !== 1"
                flat
                fab
                small
                @click="addDriver(true)"
              >
                <v-icon color="primary">edit</v-icon>
              </v-btn>
              <v-btn
                :disabled="selected.length !== 1"
                flat
                fab
                small
                @click="showDeleteDriverModal"
              >
                <v-icon color="primary">delete</v-icon>
              </v-btn>
              <v-btn
                :disabled="selected.length === 0"
                flat
                fab
                small
                @click="showSendEmailModal"
              >
                <v-icon color="primary">send</v-icon>
              </v-btn>
            </div>
          </v-expand-transition>
        </v-layout>
        <v-speed-dial
          absolute
          bottom
          left
          direction="bottom"
          open-on-hover
          transition="scale-transition"
          style="bottom: 0"
        >
          <template v-slot:activator>
            <v-tooltip right>
              <template v-slot:activator="{ on }">
                <v-btn
                  style="z-index: 99"
                  color="gradiente"
                  dark
                  small
                  fab
                  v-on="on"
                  @click="addDriver"
                >
                  <v-icon style="width: 100%">add</v-icon>
                </v-btn>
              </template>
              <span>Crear chofer nuevo</span>
            </v-tooltip>
          </template>
        </v-speed-dial>
      </v-toolbar>
      <v-container style="max-height: 30vh" class="scrollDesign">
        <v-layout row wrap>
          <v-flex xs12 class="expandableContainer">
            <v-data-table
              v-model="selected"
              :headers="headers"
              :items="chofers"
              :loading="loading"
              hide-actions
              ref="table"
              item-key="id"
              no-data-text="No tiene choferes"
              style="max-height: 18vh; overflow-y: scroll"
              select-all
            >
              <template v-slot:headers="props">
                <tr>
                  <th style="width: 78px; max-width: 78px; min-width: 78px">
                    <v-checkbox
                      :input-value="props.all"
                      :indeterminate="props.indeterminate"
                      primary
                      :disabled="loading"
                      color="primary"
                      hide-details
                      @click.stop="toggleAll"
                    ></v-checkbox>
                  </th>
                  <th
                    style="width: 200px; max-width: 200px; min-width: 200px"
                    v-for="header of props.headers"
                    :key="header.text"
                  >
                    {{ header.text }}
                  </th>
                </tr>
              </template>
              <template v-slot:items="props">
                <td style="width: 78px; max-width: 78px; min-width: 78px">
                  <v-checkbox
                    color="primary"
                    v-model="props.selected"
                    primary
                    hide-details
                    @change="toggleSingle"
                  >
                  </v-checkbox>
                </td>
                <td style="width: 200px; max-width: 200px; min-width: 200px">
                  <v-avatar
                    size="30px"
                    color="grey lighten-4"
                    v-if="
                      props.item.imageStorage &&
                      props.item.imageStorage.miniObjUrl
                    "
                  >
                    <img
                      :src="props.item.imageStorage.miniObjUrl"
                      alt="avatar"
                    />
                  </v-avatar>
                  <v-icon v-else color="blue">directions_car</v-icon>
                </td>
                <td style="width: 200px; max-width: 200px; min-width: 200px">
                  {{ props.item.firstName }}
                </td>
                <td style="width: 200px; max-width: 200px; min-width: 200px">
                  {{ props.item.lastName }}
                </td>
                <td style="width: 200px; max-width: 200px; min-width: 200px">
                  {{ props.item.mail }}
                </td>
                <td style="width: 200px; max-width: 200px; min-width: 200px">
                  <div v-if="props.item.pWchanged === true">Registrado</div>
                  <HideCode v-else :text="props.item.code"></HideCode>
                </td>
                <td style="width: 200px; max-width: 200px; min-width: 200px">
                  {{ props.item.lastLoggedIn | formatDate }}
                </td>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
      </v-container>
    </v-layout>
    <DriverModal
      :driver="modals.driver"
      v-model="modals.showAddDriver"
      :parentId="parentId"
      @created="onCreated"
      @edited="onEdited"
    />
    <Confirm
      v-model="modals.showDeleteDriver"
      title="Confirmación"
      :description="modals.description"
      @desition="$event ? deleteDriver() : ''"
    ></Confirm>
    <Confirm
      @desition="$event ? resendEmail() : ''"
      v-model="modals.sendEmail"
      title="Envío de correo"
      description="Se enviará el correo con el código de registro solo a los usuarios pendientes de registrar.<br/><br/> ¿Deseas continuar con la operación?"
    ></Confirm>
    <Loading v-model="toasts.loading" text="Trabajando"></Loading>
    <Error v-model="toasts.showFailed" :text="toasts.failedMessage"></Error>
    <success
      v-model="toasts.showSuccess"
      :text="toasts.successMessage"
    ></success>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import Confirm from '../../Dialogs/Confirm.vue'
import Error from '../../Dialogs/Error.vue'
import Loading from '../../Dialogs/Loading.vue'
import Success from '../../Dialogs/Success.vue'
import DriverModal from '../../Modals/parents/driverModal.vue'
import HideCode from '../../Tools/HideCode.vue'

export default {
  props: ['parentId'],
  components: {
    DriverModal,
    HideCode,
    Confirm,
    Error,
    Success,
    Loading,
  },
  data: () => ({
    modals: {
      showAddDriver: false,
      sendEmail: false,
      showDeleteDriver: false,
      description: '',
      driver: undefined,
    },
    toasts: {
      loading: false,
      showFailed: false,
      failedMessage: false,
      showSuccess: false,
      successMessage: '',
    },
    chofers: [],
    loading: false,
    headers: [
      {
        text: 'Foto',
        align: 'center',
        value: 'image',
        sortable: false,
        langKey: 'parents.drivers_table.photo',
      },
      {
        text: 'Nombres(s)',
        align: 'center',
        value: 'model',
        langKey: 'parents.drivers_table.first_name',
      },
      {
        text: 'Apellidos',
        align: 'center',
        value: 'plates',
        langKey: 'parents.drivers_table.last_name',
      },
      {
        text: 'Correo',
        align: 'center',
        value: 'color',
        langKey: 'parents.drivers_table.email',
      },
      {
        text: 'Estatus',
        align: 'center',
        value: 'color',
        langKey: 'parents.drivers_table.status',
      },
      {
        text: 'Último inicio de sesión',
        align: 'center',
        value: 'color',
        langKey: 'parents.drivers_table.last_login',
      },
    ],
    selected: [],
  }),
  mounted() {
    this.getChofers()
    this.setlang()
  },
  methods: {
    setlang() {
      for (let i = 0; i < this.headers.length; i++) {
        const el = this.headers[i]
        el.text = this.$t(el.langKey)
      }
    },
    getChofers() {
      this.$store
        .dispatch('tutor/getChofers', this.parentId)
        .then((response) => {
          this.loading = false
          this.chofers = response.data.entity
        })
        .catch((error) => {
          console.log(error)
          this.loading = false
        })
    },
    onCreated() {
      this.getChofers()
      this.$emit('driverCreated', this.parentId)
    },
    onEdited() {
      this.getChofers()
      this.selected = []
    },
    toggleAll() {
      if (this.selected.length) this.selected = []
      else this.selected = this.chofers.slice()
    },
    addDriver(isEdit = false) {
      if (isEdit === true) {
        this.modals.driver = structuredClone(this.selected.at(0))
      } else {
        this.modals.driver = undefined
      }
      this.modals.showAddDriver = true
    },
    showSendEmailModal() {
      this.modals.sendEmail = true
    },
    async resendEmail() {
      try {
        const selectedIds = this.selected.map((e) => e.id)
        const ids = {
          ids: selectedIds,
        }
        this.toasts.loading = true
        const response = await this.$store.dispatch('tutor/resendEmailV2', ids)
        this.toasts.loading = false
        this.toasts.successMessage = `El correo se envió a ${response.data.entity.success} de ${response.data.entity.found} choferes.`
        this.toasts.showSuccess = true
      } catch (error) {
        this.toasts.showFailed = true
        this.toasts.failedMessage = `Error al enviar correo${
          this.selected.length > 1 ? 's' : ''
        }.`
        console.log(error)
        this.toasts.loading = false
      }
    },
    showDeleteDriverModal() {
      this.modals.showDeleteDriver = true
      const driver = this.selected.at(0)
      this.modals.description = `Esta a punto de eliminar a ${driver.firstName} ${driver.lastName} ¿Está seguro que desea realizar dicha acción?`
    },
    async deleteDriver() {
      try {
        this.toasts.loading = true
        const data = {
          idOwner: this.parentId,
          idDriver: this.selected.at(0).id,
        }
        await this.$store.dispatch('tutor/deleteDriver', data)
        this.toasts.loading = false
        this._emitRemoveDriver()
        this.toasts.successMessage = `Se eliminó correctamente.`
        this.toasts.showSuccess = true
      } catch (error) {
        console.log(error)
        const customError = error.response.status === 400

        if (customError) {
          this.toasts.showFailed = true
          this.toasts.failedMessage =
            'No se encontró el tutor o el chofer indicados.'
        } else {
          this.errors.onCreate = 'Error al crear chofer.'
        }
      }
    },
    _emitRemoveDriver() {
      this.getChofers()
      this.$emit('qtyDriversRemoved', this.parentId)
    },
  },
  watch: {
    getLang() {
      this.setLang()
    },
  },
  computed: {
    ...mapGetters(['getLang']),
  },
}
</script>

<style scoped>
.no-padding {
  padding-left: 10%;
}
.position-no {
  position: absolute;
  top: 0px;
  right: 0px;
  z-index: -1;
}
td,
th {
  text-align: center !important;
  width: 150px;
  max-width: 150px;
  min-width: 150px;
}

::v-deep .v-datatable.v-table > tbody {
  max-height: 7vh;
  min-height: 7vh;
}
</style>
<style scoped>
::v-deep .v-datatable.v-table > tbody {
  max-height: initial !important;
  min-height: initial !important;
  overflow: hidden !important;
}
::v-deep .v-icon {
  width: 100%;
}
</style>
